
interface CidadeEstrategiaProps {
  cidadeFormatted: string;
  estadoNome: string;
}

const CidadeEstrategia = ({ cidadeFormatted, estadoNome }: CidadeEstrategiaProps) => {
  return (
    <section className="py-16 px-6 md:px-12 bg-seo-light">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold mb-8 text-seo-dark text-center">
          Nossa Estratégia de SEO Local para {cidadeFormatted}
        </h2>
        
        <div className="bg-white p-8 rounded-lg shadow-sm">
          <ol className="space-y-6">
            <li className="flex gap-4">
              <span className="bg-seo-primary text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0">1</span>
              <div>
                <h3 className="font-semibold text-lg">Análise do mercado local de {cidadeFormatted}</h3>
                <p className="text-gray-600">
                  Estudamos o comportamento de busca dos consumidores em {cidadeFormatted} para
                  entender o que eles procuram e como encontram empresas como a sua.
                </p>
              </div>
            </li>
            
            <li className="flex gap-4">
              <span className="bg-seo-primary text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0">2</span>
              <div>
                <h3 className="font-semibold text-lg">Otimização do Google Meu Negócio</h3>
                <p className="text-gray-600">
                  Criamos e otimizamos seu perfil no Google Meu Negócio para {cidadeFormatted},
                  garantindo que todas as informações estejam corretas e atualizadas.
                </p>
              </div>
            </li>
            
            <li className="flex gap-4">
              <span className="bg-seo-primary text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0">3</span>
              <div>
                <h3 className="font-semibold text-lg">Conteúdo localizado para {cidadeFormatted}</h3>
                <p className="text-gray-600">
                  Criamos conteúdo específico para {cidadeFormatted} em seu site, incluindo
                  páginas de destino e posts de blog focados em temas relevantes localmente.
                </p>
              </div>
            </li>
            
            <li className="flex gap-4">
              <span className="bg-seo-primary text-white rounded-full h-8 w-8 flex items-center justify-center flex-shrink-0">4</span>
              <div>
                <h3 className="font-semibold text-lg">Construção de citações locais</h3>
                <p className="text-gray-600">
                  Cadastramos sua empresa em diretórios locais importantes de {cidadeFormatted} e
                  {estadoNome}, aumentando sua autoridade e relevância para o Google.
                </p>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>
  );
};

export default CidadeEstrategia;
